<template>
  <b-card>
    <!-- form -->
    <b-form
      class="mt-2"
      @submit.prevent="handleSubmit"
    >
      <b-row>
        <!-- First Name -->
        <b-col sm="6">
          <b-form-group
            :label="$t('accountSettings.general.firstName')"
            label-for="account-first-name"
          >
            <b-form-input
              id="account-first-name"
              v-model="formData.first_name"
              :placeholder="$t('accountSettings.general.firstName')"
              name="first_name"
              maxlength="255"
              :state="getFieldState('first_name')"
              required
            />
            <b-form-invalid-feedback v-if="errors.first_name">
              {{ errors.first_name[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Last Name -->
        <b-col sm="6">
          <b-form-group
            :label="$t('accountSettings.general.lastName')"
            label-for="account-last-name"
          >
            <b-form-input
              id="account-last-name"
              v-model="formData.last_name"
              :placeholder="$t('accountSettings.general.lastName')"
              name="last_name"
              maxlength="255"
              :state="getFieldState('last_name')"
              required
            />
            <b-form-invalid-feedback v-if="errors.last_name">
              {{ errors.last_name[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Email -->
        <b-col sm="6">
          <b-form-group
            :label="$t('accountSettings.general.email')"
            label-for="account-e-mail"
          >
            <b-form-input
              id="account-e-mail"
              v-model="formData.email"
              type="email"
              name="email"
              :placeholder="$t('accountSettings.general.email')"
              maxlength="255"
              :state="getFieldState('email')"
              required
            />
            <b-form-invalid-feedback v-if="errors.email">
              {{ errors.email[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Mobile Number -->
        <b-col sm="6">
          <i-input
            id="mobile"
            v-model="formData.mobile"
            :errors="errors.mobile || []"
            type="tel"
            title="inputs.mobile"
            :dial-code="formData.mobile_code"
            :disabled="true"
            :readonly="true"
          />
          <b-form-invalid-feedback v-if="errors.mobile">
            {{ errors.mobile[0] }}
          </b-form-invalid-feedback>
        </b-col>

        <!--        &lt;!&ndash; Email Verification Alert &ndash;&gt;-->
        <!--        <b-col-->
        <!--          v-if="userData && userData.email_verified_at === null"-->
        <!--          cols="12"-->
        <!--          class="mt-75"-->
        <!--        >-->
        <!--          <b-alert-->
        <!--            show-->
        <!--            variant="warning"-->
        <!--            class="mb-50"-->
        <!--          >-->
        <!--            <h4 class="alert-heading">-->
        <!--              {{ $t('accountSettings.general.emailNotVerified') }}-->
        <!--            </h4>-->
        <!--            <div class="alert-body">-->
        <!--              <b-link class="alert-link">-->
        <!--                {{ $t('accountSettings.general.resendConfirmation') }}-->
        <!--              </b-link>-->
        <!--            </div>-->
        <!--          </b-alert>-->
        <!--        </b-col>-->

        <!-- Buttons -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
            class="mt-2 mr-1"
            :disabled="loading"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-50"
            />
            {{ loading ? $t('accountSettings.general.saving') : $t('accountSettings.general.saveChanges') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            type="reset"
            class="mt-2"
            :disabled="loading"
            @click.prevent="resetForm"
          >
            {{ $t('accountSettings.general.reset') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BLink, BFormInvalidFeedback, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getUserData, setUserData } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BLink,
    BFormInvalidFeedback,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      userData: null,
      formData: {
        first_name: '',
        last_name: '',
        email: '',
        mobile_code: '',
        mobile: '',
      },
      errors: {},
      loading: false,
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    async loadUserData() {
      this.loading = true
      try {
        const response = await this.$http.get('/dashboard/v1/merchants/profile')

        if (response.data && response.data.data) {
          this.userData = response.data.data
          setUserData(this.userData)

          this.formData = {
            first_name: this.userData.first_name || '',
            last_name: this.userData.last_name || '',
            email: this.userData.email || '',
            mobile_code: this.userData.mobile_code || '+966',
            mobile: this.userData.mobile || '',
          }
        }
      } catch (error) {
        const localUserData = getUserData()
        if (localUserData) {
          this.userData = localUserData
          this.formData = {
            first_name: localUserData.first_name || '',
            last_name: localUserData.last_name || '',
            email: localUserData.email || '',
            mobile_code: localUserData.mobile_code || '+966',
            mobile: localUserData.mobile || '',
          }
        } else {
          this.showToast('danger', this.$t('Error'), this.$t('accountSettings.messages.profileLoadError'))
        }
      } finally {
        this.loading = false
      }
    },
    getFieldState(fieldName) {
      if (this.errors[fieldName]) {
        return false
      }
      return null
    },
    resetForm() {
      this.loadUserData()
      this.errors = {}
    },
    async handleSubmit() {
      if (!this.userData || !this.userData.id) {
        this.showToast('danger', this.$t('Error'), this.$t('accountSettings.messages.profileLoadError'))
        return
      }

      this.loading = true
      this.errors = {}

      try {
        const response = await this.$http.put(
          `/dashboard/v1/merchants/${this.userData.id}`,
          {
            first_name: this.formData.first_name,
            last_name: this.formData.last_name,
            email: this.formData.email.toLowerCase(),
            mobile_code: this.formData.mobile_code,
            mobile: this.formData.mobile.replace(/\s+/g, ''),
          },
        )

        if (response.data && response.data.data) {
          setUserData(response.data.data)
          this.userData = response.data.data

          this.showToast('success', this.$t('message.operation_success'), this.$t('accountSettings.messages.profileUpdated'))
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 422 && error.response.data.errors) {
            this.errors = error.response.data.errors
            this.showToast('danger', this.$t('message.generic_validation_error'), this.$t('accountSettings.messages.validationError'))
          } else if (error.response.status === 401) {
            this.showToast('danger', this.$t('errors.not_authorized.title'), this.$t('accountSettings.messages.unauthorized'))
          } else if (error.response.status === 404) {
            this.showToast('danger', this.$t('errors.not_found.title'), this.$t('accountSettings.messages.notFound'))
          } else {
            this.showToast('danger', this.$t('Error'), error.response.data.message || this.$t('accountSettings.messages.updateError'))
          }
        } else {
          this.showToast('danger', this.$t('Error'), this.$t('accountSettings.messages.networkError'))
        }
      } finally {
        this.loading = false
      }
    },
    showToast(variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertCircleIcon',
          variant,
          text,
        },
      })
    },
  },
}
</script>
